import { initISWSideEffect } from "../../shared/components/isw-side-effects/create-isw-helpers";
import { InkomstenAanmerkelijkBelangModalType } from "../infra/inkomen-en-fiscus-schema";
import { determineGemiddeldInkomensVerleden } from "../infra/shared-components/determine-inkomensverleden-side-effects";

export const inkomenstenAanmerkelijkBelangModalSideEffects = initISWSideEffect<InkomstenAanmerkelijkBelangModalType>(
  bag => {
    determineGemiddeldInkomensVerleden(bag.subset.inkomensverleden.create());
  }
);
